<script setup lang="ts">
const { clean } = useDompurify()
const router = useRouter()

const show = ref(false)
const popInfo = ref<any>({})
useLockAppScrollWhenVisible(show)

const open = (info: any) => {
  show.value = true
  popInfo.value = info
  baseService.triggerPopUp({ id: popInfo.value.id })
}
const close = () => {
  show.value = false
}
const jumpPage = () => {
  show.value = false
  if (popInfo.value.jumpType === 'outside') {
    window.open(popInfo.value.jumpUrl)
  } else if (popInfo.value.jumpType === 'inside') {
    router.push({ name: popInfo.value.jumpUrl })
  }
}
defineExpose({
  open,
  close,
})
</script>

<template>
  <n-modal
    v-model:show="show"
    class="z-60"
    transform-origin="center"
    :on-after-leave="close"
    :mask-closable="true"
  >
    <div class="sm:w-105 sm:pt-8 sm:px-6 w-85.75 pt-7 pb-6 px-4 modal-content relative">
      <div i-carbon:close class="cursor-pointer text-6 absolute top-6 right-5" @click="close" />
      <div>
        <div class="flex flex-col items-center">
          <img
            v-if="isDark"
            src="@/assets/newLogo/Logo_full_brand_color.webp"
            class="h-12 mb-7 rounded-full"
            alt="dfans"
          />
          <img
            v-else
            src="@/assets/newLogo/Logo_full_brand_color_1.webp"
            class="h-12 mb-7 rounded-full"
            alt="dfans"
          />
        </div>
        <div class="!text-base !leading-6" v-html="clean(popInfo.content)" />
        <div class="w-full flex justify-between">
          <DfansButton
            :text="popInfo.jumpButtonText"
            class="sm:w-62 mt-8 w-full mx-auto h-11"
            type="default"
            @click="jumpPage"
          />
        </div>
      </div>
    </div>
  </n-modal>
</template>
